import { SKINS } from '../../themes/skins';
import { buildCatalog, skinProductId } from '../catalog';
import { grantRemoveAds, grantSkin, readEntitlements } from '../entitlements';
import { trackEvent } from '../events';
import { IapProvider, PurchaseResult, StoreProduct } from '../iap';

export class DemoIapProvider implements IapProvider {
  initialize(): Promise<void> {
    return Promise.resolve();
  }

  getProducts(): Promise<StoreProduct[]> {
    return Promise.resolve(buildCatalog());
  }

  purchase(productId: string): Promise<PurchaseResult> {
    const product = buildCatalog().find((entry) => entry.id === productId);
    if (!product) {
      trackEvent('purchase_failed', { productId, provider: 'demo', reason: 'unknown-product' });
      return Promise.resolve('unavailable');
    }
    trackEvent('skin_purchase_started', { productId, provider: 'demo' });
    if (product.grants === 'remove-ads') {
      grantRemoveAds();
    } else if (product.grants === 'skin' && product.skinId) {
      grantSkin(product.skinId);
    } else if (product.grants === 'all-skins') {
      for (const skin of SKINS) {
        grantSkin(skin.id);
      }
    }
    trackEvent('purchase_completed', { productId, provider: 'demo' });
    return Promise.resolve('purchased');
  }

  restore(): Promise<string[]> {
    const entitlements = readEntitlements();
    const restored: string[] = [];
    if (entitlements.adsRemoved) {
      restored.push('remove_ads');
    }
    for (const skin of entitlements.ownedSkins) {
      if (skin !== 'sketchbook') {
        restored.push(skinProductId(skin));
      }
    }
    trackEvent('purchases_restored', { provider: 'demo', count: restored.length });
    return Promise.resolve(restored);
  }
}
